import {
  getDietIdWithTierId,
  getDietNameWithTierName,
} from './mergeDietIdAndTierId.util';

export const extractDietsAndTiers = programs => {
  const diets = [];
  const tiers = [];

  programs.forEach(({ menuConfigurationTier, diets: programDiets = [] }) => {
    programDiets.forEach((diet = {}) => {
      const {
        dietId,
        name: dietName,
        imageUrl: dietImageUrl,
        dietTag,
        dietTiers = [],
      } = diet;

      if (menuConfigurationTier) {
        dietTiers.forEach(({ tierId, name: tierName, imageUrl }) => {
          tiers.push({
            dietIdWithTierId: getDietIdWithTierId(dietId, tierId),
            dietImageUrl: imageUrl ?? null,
            dietName: getDietNameWithTierName(dietName, tierName),
            dietTag,
          });
        });
      } else {
        diets.push({
          dietIdWithTierId: getDietIdWithTierId(dietId),
          dietImageUrl,
          dietName,
          dietTag,
        });
      }
    });
  });

  return [...tiers, ...diets];
};
